import BackButtonToolbar from "features/BackButtonToolbar";
import InactiveDeleteOptionEditToolbar from "features/EditToolbar";
import {
  ArrayInput,
  maxLength,
  ReferenceInput,
  required,
  ResourceContextProvider,
  SelectInput,
  SimpleForm,
  SimpleFormIterator,
  TextInput,
  Title,
  useGetList,
  useNotify,
  useRedirect,
} from "react-admin";
import { Grid } from "@mui/material";
import dataProvider from "server/dataProvider";
import { useParams } from "react-router-dom";
import { CURRICULUMS, StudentServicePath } from "utils/constants";
import { settings } from "app";
import { studentRequests } from "api/studentApi";
import { useNotifyError } from "utils/useNotifyError";

const EditCyclicExamExceptions = () => {
  const notifyError = useNotifyError();
  const notify = useNotify();
  const redirect = useRedirect();
  const { id } = useParams();

  const { data } = useGetList(studentRequests.getCurriculumCyclicExamExceptions(id), {});

  const handleSubmit = async values => {
    try {
      await dataProvider.customRequest(studentRequests.updateCurriculumCyclicExamExceptions(id), values, "PUT");
      notify("Успешно редактирахте комплексни изпити");
      redirect(-1);
    } catch (err) {
      notifyError(err);
    }
  };

  return (
    <>
      <Title title="Редактиране на информация за комплексни изпити" />
      <BackButtonToolbar />
      <ResourceContextProvider value={`${StudentServicePath}${CURRICULUMS}`}>
        {data && (
          <SimpleForm
            toolbar={<InactiveDeleteOptionEditToolbar />}
            onSubmit={handleSubmit}
          >
            <ArrayInput
              source="pairs"
              label=""
              defaultValue={data}
            >
              <SimpleFormIterator
                sx={settings.style.iteratorWithoutGap}
                disableReordering
                disableClear
              >
                <Grid
                  container
                  spacing={2}
                >
                  <Grid
                    item
                    xs={12}
                    md={4}
                  >
                    <TextInput
                      source="examName"
                      label="Име на изпита"
                      validate={[required(), maxLength(100)]}
                    />
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    md={4}
                  >
                    <ReferenceInput
                      source="cyclicDisciplineId"
                      reference={studentRequests.getCurriculumCyclicDisciplinesSelect(id)}
                    >
                      <SelectInput
                        optionText="name"
                        label="Циклична дисциплина"
                        emptyText={false}
                        validate={required()}
                      />
                    </ReferenceInput>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    md={4}
                  >
                    <ReferenceInput
                      source="regularDisciplineId"
                      reference={studentRequests.getCurriculumDisciplinesSelect(id)}
                    >
                      <SelectInput
                        optionText="name"
                        label="Дисциплина"
                        emptyText={false}
                        validate={required()}
                      />
                    </ReferenceInput>
                  </Grid>
                </Grid>
              </SimpleFormIterator>
            </ArrayInput>
          </SimpleForm>
        )}
      </ResourceContextProvider>
    </>
  );
};

export default EditCyclicExamExceptions;
